/**
 * Dashboard inicial do painel Admin White Label (/wl)
 * Fase 1 — placeholder com cards de seções disponíveis ao operador.
 */
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Building2, Plug, Users, DollarSign, UserCog, Shield, Activity, Settings, CreditCard, Package } from 'lucide-react';
import { useWlPermissions } from '@/contexts/WlPermissionsContext';

const SECTIONS = [
  { key: 'wl.tenants',       title: 'Tenants',              description: 'Gerenciar tenants do white label',     url: '/wl/tenants',      icon: Building2 },
  { key: 'wl.instances',     title: 'Instâncias',           description: 'Gerenciar instâncias de provider',     url: '/wl/instances',    icon: Plug },
  { key: 'wl.tenant_users',  title: 'Usuários dos Tenants', description: 'Convidar, alterar role, remover',      url: '/wl/tenant-users', icon: Users },
  { key: 'wl.plans',         title: 'Planos',               description: 'Cadastro de planos de assinatura',     url: '/wl/plans',        icon: CreditCard },
  { key: 'wl.addons',        title: 'Add-ons',              description: 'Cadastro de add-ons disponíveis',      url: '/wl/addons',       icon: Package },
  { key: 'wl.financial',     title: 'Financeiro',           description: 'Planos, assinaturas e cobranças',      url: '/wl/financial',    icon: DollarSign },
  { key: 'wl.wl_users',      title: 'Operadores WL',        description: 'Equipe interna do white label',        url: '/wl/operators',    icon: UserCog },
  { key: 'wl.wl_roles',      title: 'Perfis e Permissões',  description: 'Configurar acessos granulares',        url: '/wl/roles',        icon: Shield },
  { key: 'wl.audit',         title: 'Auditoria',            description: 'Log de ações no painel /wl',           url: '/wl/audit',        icon: Activity },
  { key: 'wl.settings',      title: 'Configurações',        description: 'Branding e preferências',              url: '/wl/settings',     icon: Settings },
];

export default function WlDashboard() {
  const { canView, isObserver, displayName, roleName } = useWlPermissions();
  const visible = SECTIONS.filter(s => isObserver || canView(s.key));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Bem-vindo, {displayName ?? 'Operador'}</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Painel Admin White Label{roleName ? ` • ${roleName}` : ''}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {visible.map(s => (
          <Link to={s.url} key={s.key} className="group">
            <Card className="hover:border-primary/50 hover:shadow-md transition-all h-full">
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <s.icon className="h-5 w-5 text-primary" />
                </div>
                <CardTitle className="text-base mt-2">{s.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-xs">{s.description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
